import React from "react";
import Comment from "./Comment";
import CommentsList from "./CommentsList";

const Comments = () => {
  const comments = [
    {
      name: " @anjaliofficialyt2m634",
      time: "1 year ago",
      message: `Thanks so much! Brilliant, quick, easy to follow and straight to the point video! My first ever React site is live, thanks again!`,

      replies: [
        {
          name: "@Deepak_Gupta724",
          time: "1 year ago",
          message: `  Man that was so easy and quick. Very Helpful`,
          replies: [
            {
              name: "@sumitpoddar9203",
              time: "1 year ago",
              message: ` Salute u man i was struggling since 1 month thanks a lot and may God bless u `,
            },

            {
              name: "@DineshKumar-mn5ts",
              time: "1 year ago",
              message: `Glad it helped`,
            },
          ],
        },
        ,
        {
          name: "@Deepak_Gupta724",
          time: "1 year ago",
          message: " just superb i am also stuck in deploy part but your video gave me how to deploy thank u",
        },
      ],
    },
    {
      name: "@Deepak_Gupta724",
      time: "1 year ago (edited)",
      message: `Thank You! It worked and was super easy :)`,
    },
    {
      name: "@pravinsingh8746",
      time: "1 year ago",
      message: `Life saving video, thank you so much sir, clean and clear explanation`,
    },
    {
      name: "@chandusachin8206",
      time: "1 year ago",
      message: `Very nice song `,
    },

    {
      name: "@chandusachin8206",
      time: "1 year ago",
      message: "Nice song ",
      replies: [
        {
          name: "@Rohitverma-ii3xe",
          time: "1 year ago",
          message: "Only God know how glad I am. Thanks bro",
        },
      ],
    },

    {
      name: "@Yaduvanshi_lavalesh_4149",
      time: "2 years ago",
      message:
        "जो अभी अभी इस गीत को सुन रहा है भगवान करे उनके माता-पिता की लम्बी आयु हो....️️️",
      replies: [
        {
          name: "@RavindraKumar-xo6pv",
          time: "1 year ago",
          message: "Thank you",
        },
      ],
    },
    {
      name: "@Rahul_Raaina",
      time: " 2 months ago",
      message: "Easy . Crisp .To The Point . Useful",
      replies: [
        {
          name: "@mithunbihari8107",
          time: "1 month ago",
          message: "Hi",
        },
        {
          name: "@Chandankumar-ft2ox",
          time: "1 month ago",
          message: "Main 2028 me sun raha hu",
          replies: [
            {
              name: "@AdityaRaj-wv7sf",
              time: "3 weeks ago",
              message: "मैं ",
              replies: [
                {
                  name: "@RANJEETKUMAR-ri2gg",
                  time: "5 days ago",
                  message: "Purana songs best songs",
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  return (
    <div>
      <CommentsList comments={comments} />
    </div>
  );
};

export default Comments;
